export const STRINGS = {
  NA: "N/A",
  DEFAULT_VALUE: "Not Set",
  SEE_FORM: "See Form",
  NO_ACTION_ITEMS: "No action items found",
  MODAL_SUCCESS_TITLE: "Action Item Status Update",
  MODAL_SUCCESS_DESCRIPTION: "Action Item status has been successfully updated",
  MODAL_ERROR_TITLE: "Error updating Action Item Status",
};
